import { mdiEmail, mdiEmailOutline } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const Mail = (props: IconProps) => {
    const { filled, title, size = 1, ...other } = props
    return (
        <Icon
            data-testid="Icon__Mail"
            path={filled ? mdiEmail : mdiEmailOutline}
            title={title}
            size={size}
            {...other}
        />
    )
}

export default Mail
